import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";

import _ from "i18n";
import { TTP_API_URL } from "Config";
import { fetchMail } from "Thunks";

import { getDateLabel, getUserNameForAvatar } from "Utils";
import classnames from "classnames";
import styles from "./Viewer.local.scss";

class Content extends PureComponent {
  componentDidMount() {
    const { fetchMail, currentMail } = this.props;
    fetchMail(currentMail.id);
  }
  renderAvatar() {
    const { user } = this.props;
    const { id, firstName, lastName, avatar, avatarUrl } = user;
    return avatarUrl || avatar ? (
      <div
        key={`av-${id}`}
        className={styles.avatar}
        style={{
          backgroundImage: `url(${
            avatarUrl ? avatarUrl : TTP_API_URL + "/" + avatar
          })`
        }}
      />
    ) : (
      <div className={classnames(styles.avatar, "empty-avatar")}>
        <span>{getUserNameForAvatar(firstName, lastName)}</span>
      </div>
    );
  }

  render() {
    const { currentMail } = this.props;

    if (!currentMail) {
      return null;
    }

    const { from, fromName, object, preview, date, sentAt, cid } = currentMail;

    const helpDate = date ? date.date : sentAt ? sentAt.date : null;

    return (
      <Fragment>
        <div className="cell rmodal__body">
          <div className={styles.metas}>
            <div className={styles.infos}>
              <h4>{fromName}</h4>
              <p>{object}</p>
              <span>
                De:<strong>{from}</strong>
              </span>
            </div>
            <div className={styles.date}>
              <span className={styles.dateTime}>{getDateLabel(helpDate)}</span>
              {this.renderAvatar()}
            </div>
          </div>
          <div className={styles.link}>
            <a
              href={`${TTP_API_URL}/mailing/web-version/${cid}`}
              alt={object}
              target="_blanck"
            >
              <i className="icon icon-share-alt" />
              <span>{_("Web version")}</span>
            </a>
          </div>
          <div className={styles.content}>
            <iframe srcdoc={preview} title={object} />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentMail: state.mailViewer.currentMail,
  user: state.auth.user
});
const mapDispatchToProps = dispatch => ({
  fetchMail: mailId => dispatch(fetchMail(mailId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content);



// WEBPACK FOOTER //
// ./src/components/Reveal/MailViewer/Content.js